<script setup lang="ts">
    import { cn } from '@/lib/utils';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import DataTableSortButton from '@/components/datatable/DataTableSortButton.vue';
    import type { Column, Table } from '@tanstack/vue-table';
    import HoverInfo from '@/components/HoverInfo.vue';

    const { t } = useI18n();

    interface DataTableColumnHeaderProps {
        column: Column<any, any>;
        table?: Table<any>;
        title: string;
        info?: string;
    }

    const props = defineProps<DataTableColumnHeaderProps>();

    const hasSelectedRows = computed(() => {
        return props.table && props.table.getFilteredSelectedRowModel().flatRows.length > 0;
    });

    const title = computed(() => {
        return t(props.title);
    });
</script>

<template>
    <div :class="cn('flex items-center gap-1', $attrs.class ?? '')">
        <DataTableSortButton
            v-if="column.getCanSort()"
            :column="column"
            :title="title"
            :table-has-selected-rows="hasSelectedRows"
        />
        <span v-else>
            {{ title }}
        </span>
        <HoverInfo
            v-if="info"
            :content="t(info)"
        />
    </div>
</template>
